import Popper from 'popper.js/dist/popper'
window.Popper = Popper
